module.exports = __webpack_public_path__ + "img/pin-set.40c4b552.svg";